import React from "react";
import {
  FieldError,
  FieldErrorsImpl,
  Merge,
  UseFormRegisterReturn,
} from "react-hook-form";

interface InputFieldProps {
  id: string;
  label: string;
  placeholder?: string;
  register?: UseFormRegisterReturn;
  error?: FieldError | Merge<FieldError, FieldErrorsImpl<any>>;
  isReadOnly?: boolean;
  value?: string | number;
  type?: "text" | "number" | "password" | "email";
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  icon?: React.ReactNode;
  onIconClick?: () => void;
  iconPosition?: "left" | "right";
  maxLength?: number;
}

const InputWithIcon: React.FC<InputFieldProps> = ({
  id,
  label,
  placeholder,
  register,
  error,
  isReadOnly = false,
  value,
  type = "text",
  onChange,
  icon,
  onIconClick,
  iconPosition = "right",
  maxLength,
}) => {
  const iconElement = icon && (
    <span
      className={`absolute top-1/2 -translate-y-1/2 ${iconPosition === "right" ? "right-2" : "left-2"} cursor-pointer`}
      onClick={onIconClick}
    >
      {icon}
    </span>
  );

  return (
    <div className="relative w-full">
      <label htmlFor={id} className="text-base text-light-soft-elevation-02">
        {label}
      </label>
      <div className="relative">
        {iconPosition === "left" && iconElement}
        <input
          id={id}
          type={type}
          placeholder={placeholder}
          {...(register ? register : {})}
          readOnly={isReadOnly}
          autoComplete={isReadOnly && value ? value.toString() : undefined}
          defaultValue={value}
          onChange={onChange}
          maxLength={maxLength}
          className={`w-full ${icon && iconPosition === "left" ? "pl-10" : "pl-2"} ${
            icon && iconPosition === "right" ? "pr-10" : "pr-2"
          } border-2 rounded-sm outline-none text-gray h-11 ${
            isReadOnly
              ? "bg-transparent border-light-gray cursor-default"
              : "bg-interactive-cyan border-deep-blue/60"
          } ${error ? "border-interactive-red bg-interactive-light-red" : ""}`}
        />
        {iconPosition === "right" && iconElement}
      </div>
      {error?.message && (
        <span className="absolute flex text-xs text-interactive-red">
          {String(error.message)}
        </span>
      )}
    </div>
  );
};

export default InputWithIcon;
